import { FC, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useFormContext, useWatch } from "react-hook-form";

import CommentAuthorBg from "@/assets/icons/comment-author.svg";
import { ProductionSceneCommentResource } from "@/types/resources";
import { SceneFormT } from "./ProductionScriptBlock";

interface Position {
  top: number;
  left: number;
}

const Box = styled.button.attrs({ type: "button" })<Position>`
  position: absolute;
  width: 28px;
  height: 28px;
  background-image: url(${CommentAuthorBg});
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ top, left }) => css`
    top: ${top - 40}px;
    left: ${left}px;
  `}
`;

const Avatar = styled.img`
  width: 22px;
  height: 22px;
  object-fit: cover;
  border-radius: 50%;
`;

interface Props {
  onClick: () => void;
  author: ProductionSceneCommentResource["author"];
  commentId: number;
}

const SceneComment: FC<Props> = ({ onClick, author, commentId }) => {
  const [position, setPosition] = useState<Position | null>(null);

  const { control } = useFormContext<SceneFormT>();

  const content = useWatch({
    control,
    name: "content",
  });

  useEffect(() => {
    const el = document.querySelector(
      `[data-comment="${commentId}"]`
    ) as HTMLSpanElement;

    if (!el) return setPosition(null);

    setPosition({
      left: el.offsetLeft,
      top: el.offsetTop,
    });
  }, [commentId, content]);

  if (!position) return null;

  return (
    <Box {...position} onClick={onClick}>
      <Avatar src={author.avatar} alt={author.name} />
    </Box>
  );
};

export default SceneComment;
